import { Field } from 'react-final-form';
import cx from 'classnames';
import { TextInput } from '@wkda/styleguide';
import { jsx as _jsx } from "react/jsx-runtime";
export function textInputRenderer(_ref) {
  let {
    className = '',
    name,
    onChange,
    onFocus,
    onBlur,
    mktSelector,
    format,
    parse,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    render: _ref2 => {
      let {
        input
      } = _ref2;
      const {
        type: _type,
        value,
        ...restInput
      } = input;
      return /*#__PURE__*/_jsx(TextInput, {
        bare: true,
        className: cx('carlead-creation-field__control', className),
        value: value ?? '',
        ...props,
        ...restInput,
        id: input.name,
        onChange: value => {
          restInput.onChange(value);
          onChange?.(value);
        },
        onFocus: evt => {
          restInput.onFocus(evt);
          onFocus?.(evt);
        },
        onBlur: evt => {
          restInput.onBlur(evt);
          onBlur?.(evt);
        },
        mktSelector: mktSelector?.value
      });
    },
    format: format,
    parse: parse
  });
}